import { getRegion } from '../components/regionWrapper';
import { Region } from '../utils/commonInterfaces';
import Cookies from 'js-cookie';
import { getExportAxiosRequestByRegion } from '../utils/getExportAxiosRequestByRegion';

export const postApi = (api: string, info: any) => {
    const region = getRegion();
    const axios = getExportAxiosRequestByRegion(region as Region);
    return async (_dispatch: any) => {
        try {
            if (region === Region.SE) {
                const { data } = await axios(api, {
                    data: info,
                    method: 'POST',
                    headers: {},
                    withCredentials: true
                });
                return {
                    payload: data
                };
            } else {
                const token = Cookies.get('token');
                const { data } = await axios(api, {
                    data: info,
                    method: 'POST',
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                return {
                    payload: data
                };
            }
        } catch (e: any) {
            return {
                error: true,
                payload: e?.response?.data,
            };
        }
    }
}
